import { render, staticRenderFns } from "./ImportDocuments_view.vue?vue&type=template&id=0cb42e29&scoped=true"
import script from "./ImportDocuments_view.vue?vue&type=script&lang=js"
export * from "./ImportDocuments_view.vue?vue&type=script&lang=js"
import style0 from "./ImportDocuments_view.vue?vue&type=style&index=0&id=0cb42e29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb42e29",
  null
  
)

export default component.exports